import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import { Link } from "src/components/Link";
import { Statuses } from "src/@types/deals";
import { STATUSES } from "./constants";

interface Props {
  status: Statuses;
  className?: string;
  href?: string;
  isActiveStatus: boolean;
}

export const StatusIndicator: FC<Props> = ({
  status,
  className: customClassName,
  href = "",
  isActiveStatus,
}) => {
  const { t } = useTranslation();

  const { title, icon: Icon, className } = STATUSES[status];

  const translatedTitle =
    typeof title === "string" ? title : t(title.i18nKey, title.i18nParams);

  return (
    <Link
      href={href}
      className={cn(
        className,
        "flex items-center justify-center flex-1 w-full gap-2 py-4 font-medium bg-gray-light md:bg-white-pink border border-black-base/20 rounded-20",
        { "hover:bg-gray-light": isActiveStatus },
        customClassName
      )}
    >
      <Icon />
      <span>{translatedTitle}</span>
    </Link>
  );
};
